import React from "react";
import { Phone, Mail, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyForAConsultation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const phone = "(925) 529-5005";
  const email = "info@pchbuilders.com";
  const phoneHref = "tel:+1" + phone.replace(/\D/g, "");
  const emailHref = `mailto:${email}`;
  return <section data-section-id="3667" id="request-a-free-structural-deck-consultation" ref={ref} className={`dark relative w-full py-24 md:py-32 overflow-hidden bg-background text-foreground transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/75 z-10" />
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat blur-sm scale-105" className="bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631011/img/construction_site_blurred_dark.png)] bg-cover bg-center w-full h-full" />
      </div>

      <div className="relative z-20 container mx-auto px-4 text-center">
        <div className="max-w-3xl mx-auto space-y-8">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold tracking-tight text-white drop-shadow-xl">
            Ready for a Structural Deck Consultation?
          </h2>
          
          <p className="text-lg md:text-xl font-default text-gray-300 max-w-2xl mx-auto">
            Expert California deck builders since 1990. Contact PCH Builders today for a professional site visit and structural assessment.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            {}
            <Button asChild size="lg" className="w-full sm:w-auto text-base font-default font-semibold h-14 px-8 bg-primary hover:bg-primary/90 text-primary-foreground border-none rounded-sm shadow-lg shadow-black/40 transition-all active:scale-95">
              <Link to={phoneHref}>
                <Phone className="mr-2 h-5 w-5" />
                Call (925) 529-5005
              </Link>
            </Button>

            {}
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base font-default font-semibold h-14 px-8 bg-transparent border-white/20 text-white hover:bg-white hover:text-secondary rounded-sm transition-colors backdrop-blur-md">
              <Link to={emailHref}>
                <Mail className="mr-2 h-5 w-5" />
                Email Us
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}